import { useTranslation } from 'react-i18next'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

interface RelaunchingAudienceDialogProps {
  open: boolean
  onCancel: () => void
  onConfirm: () => void
}

export function RelaunchingAudienceDialog({
  open,
  onCancel,
  onConfirm,
}: RelaunchingAudienceDialogProps) {
  const { t } = useTranslation('app')
  return (
    <AlertDialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) {
          onCancel()
        }
      }}
    >
      <AlertDialogContent data-testid="relaunching-audience-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>{t('audienceActions.reprocessing')}</AlertDialogTitle>
          <AlertDialogDescription>
            This audience is currently being refreshed. The new version will be
            available very soon. You can continue building on the previous
            version now — it stays live until the new run completes.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel} data-testid="relaunching-dialog-cancel">{t('cancel', { ns: 'common' })}</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} data-testid="relaunching-dialog-confirm">
            {t('audienceActions.buildPrevious')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
